import { GetBuildingSearchResObj } from '@gateway.Building'
import { StackLayout } from '@progress/kendo-react-layout'
import { Dispatch, FC, SetStateAction } from 'react'
import { ErrorMessage } from '../../../components/parts'
import { Authority } from '../../../gateway/system/Authority'
import { UserProperty } from '../../../gateway/system/UserProperty'
import { BuildingSearchCard } from './BuildingSearchCard'

export interface BuildingSearchResultListProps {
  skip: number
  userProp?: UserProperty
  onSearchBtnClick: () => void
  setNotificationMessages: Dispatch<SetStateAction<ErrorMessage[]>>
  setErrorMessages: Dispatch<SetStateAction<ErrorMessage[]>>
  setBuildingSearchData: Dispatch<SetStateAction<GetBuildingSearchResObj>>
  setOkButtonDisabled: Dispatch<SetStateAction<boolean>>
  buildingSearchDataState: GetBuildingSearchResObj
  setIsChanged: Dispatch<React.SetStateAction<boolean>>
  buildingSearchDataStore: GetBuildingSearchResObj
  setBuildingSearchDataState: React.Dispatch<React.SetStateAction<GetBuildingSearchResObj>>
  target: string
  setTarget: Dispatch<SetStateAction<string>>
  sourceBuilding: string
  setSourceBuilding: Dispatch<SetStateAction<string>>
  destinationBuilding: string
  setDestinationBuilding: Dispatch<SetStateAction<string>>
}
export const BuildingSearchResultList: FC<BuildingSearchResultListProps> = (
  props
) => {
  const isSupplier = props.userProp?.authority === Authority.Supplier

  return (
    <StackLayout orientation="vertical" gap={5}>
      <span style={{ textAlign: 'right', color: '#d51923', fontWeight: '700', fontSize: '16px' }}>※帳票対象外の対象は「山積シミュレーション出力」「消化高シミュレーション出力」「山積管理表出力」となります</span>
      {props.buildingSearchDataStore.buildingInfoList.map((item) => {
        const key = `${item.buildingInfo.procurementNo ?? ''}-${item.buildingInfo.subNo ?? ''}`
        return (
          <BuildingSearchCard
            key={key}
            isSupplier={isSupplier}
            buildingInfo={item.buildingInfo}
            userProp={props.userProp}
            allowBuildingSplit={item.buildingInfo.allowBuildingSplit}
            updDtmBuildingHistoryStatus={item.buildingInfo.updDtmBuildingHistoryStatus}
            onSearchBtnClick={props.onSearchBtnClick}
            setBuildingSearchData={props.setBuildingSearchData}
            setOkButtonDisabled={props.setOkButtonDisabled}
            setNotificationMessages={props.setNotificationMessages}
            setErrorMessages={props.setErrorMessages}
            buildingSearchDataState={props.buildingSearchDataState}
            setIsChanged={props.setIsChanged}
            buildingSearchDataStore={props.buildingSearchDataStore}
            setBuildingSearchDataState={props.setBuildingSearchDataState}
            target={props.target}
            setTarget={props.setTarget}
            sourceBuilding={props.sourceBuilding}
            setSourceBuilding={props.setSourceBuilding}
            destinationBuilding={props.destinationBuilding}
            setDestinationBuilding={props.setDestinationBuilding}
          />
        )
      })}
    </StackLayout>
  )
}
